export default __webpack_public_path__ + "static/media/include_14_male@3x.8b1285a6.jpg";